import React from "react";
import { motion } from "framer-motion";
import {
  FaHtml5,
  FaCss3Alt,
  FaReact,
  FaNodeJs,
  FaPython,
  FaGithub,
} from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io5";
import { SiTailwindcss, SiExpress, SiJavascript } from "react-icons/si";
import { DiMongodb, DiMysql } from "react-icons/di";
import { BiLogoCPlusPlus, BiLogoSpringBoot } from "react-icons/bi";
import { FaJava } from "react-icons/fa";
import { IoMdGitBranch } from "react-icons/io";
import { useSelector } from "react-redux";

const skills = [
  { id: 1, icon: <FaHtml5 size={58} />, color: "text-orange-500" },
  { id: 2, icon: <FaCss3Alt size={58} />, color: "text-blue-500" },
  { id: 3, icon: <SiJavascript size={58} />, color: "text-yellow-500" },
  { id: 4, icon: <FaReact size={58} />, color: "text-cyan-400" },
  { id: 5, icon: <SiTailwindcss size={58} />, color: "text-cyan-500" },
  { id: 5, icon: <FaNodeJs size={58} />, color: "text-green-700" },
  { id: 5, icon: <SiExpress size={58} />, color: "text-orange-500" },
  { id: 5, icon: <DiMongodb size={58} />, color: "text-green-500" },
  { id: 6, icon: <FaJava size={58} />, color: "text-red-600" },
  { id: 7, icon: <IoMdGitBranch size={58} />, color: "text-green-600" },
];

const SkillsSection = () => {
  const theme = useSelector((state) => state.theme.theme);
  const baseClasses =
    "flex justify-center items-center w-[130px] h-[130px] py-4 px-5 rounded-xl transition-all cursor-pointer relative overflow-hidden shadow-lg bg-white dark:bg-gray-900";

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="flex flex-col items-center py-20 px-6 lg:px-0"
    >
      {/* Title Section */}
      <div className="w-full max-w-4xl text-center">
        <h2 className="text-[38px] lg:text-[48px] font-bold">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-blue-500 to-cyan-400">
            Skills
          </span>
        </h2>
        <p className="text-gray-500 dark:text-gray-400 mt-3">
          A collection of technologies and tools I specialize in.
        </p>
      </div>

      {/* Skills Grid */}
      <div className="w-full flex flex-col lg:flex-row justify-center items-center space-y-10 lg:space-y-0 mt-14">
        <div className="hidden lg:flex flex-wrap justify-center gap-x-[70px] gap-y-[70px] w-full">
          {skills.map((skill) => (
            <motion.div
              key={skill.id}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: skill.id * 0.1 }}
              whileHover={{ scale: 1.15 }}
              whileTap={{ scale: 0.95 }}
              className={baseClasses}
            >
              <motion.span className={`relative z-10 ${skill.color}`}>
                {skill.icon}
              </motion.span>
            </motion.div>
          ))}
        </div>

        {/* Mobile View */}
        <div className="lg:hidden grid grid-cols-2 gap-x-6 gap-y-6 place-items-center">
          {skills.map((skill) => (
            <motion.div
              key={skill.id}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: skill.id * 0.1 }}
              whileHover={{ scale: 1.15 }}
              whileTap={{ scale: 0.95 }}
              className={baseClasses}
            >
              <motion.span className={`relative z-10 ${skill.color}`}>
                {skill.icon}
              </motion.span>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default SkillsSection;
